// ----------------------------------------------------------------------
// <copyright file="Izenda.FullLayout.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var classnames = require('classnames');
  var Container = require('Izenda.Container');
  var TopMenu = require('share/components/layout/Izenda.TopMenu');
  var Footer = require('share/components/layout/Izenda.Footer');
  var UserMenu = require('share/components/layout/Izenda.UserMenu');
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var connect = require('share/enhancers/Izenda.Connect');
  var BottomNotification = require('share/components/controls/Izenda.BottomNotification');
  var LicenseStatusNotification = require('modules/Settings/LicenseChecker/Izenda.LicenseStatusNotification');
    
  var FullLayout = React.createClass({
    render: function(){
      const isIframeExported = routeUtils.checkIframeExported();
      const mainClassName = classnames('izenda-Main', {
        'izenda-Main-Iframe-export': isIframeExported
      });

      return (
        <article className="izenda-Wrapper">
          { !isIframeExported && <header className="izenda-Header">
            <TopMenu />
            <UserMenu />
          </header> }
          <main className={mainClassName}>
            { this.props.children }
          </main>
          { !isIframeExported && <BottomNotification>
            <LicenseStatusNotification />
          </BottomNotification> }
          { !isIframeExported && <Footer /> }
        </article>);
    }
  });

  module.exports = connect()(FullLayout);
} ();



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.FullLayout.jsx